import {
  createContext, ReactNode, useMemo,
} from 'react';
import { FloatingWindow } from 'types/app.types';
import useFloatingWindowsState from './useFloatingWindowsStatus';

interface FloatingWindowsContextValues {
  setFloatingWindowsList: (index: string, position: {top: number, left: number}) => void
  floatingWindowsList: FloatingWindow[]
}

const FloatingWindowsContext = createContext<FloatingWindowsContextValues>({
  floatingWindowsList: [],
  setFloatingWindowsList: () => {},
});

interface FloatingWindowsProviderProps {
    children: ReactNode,
  }

function FloatingWindowsProvider({ children } : FloatingWindowsProviderProps) {
  const { floatingWindowsList, setFloatingWindowsList } = useFloatingWindowsState();

  const value = useMemo(() => ({
    floatingWindowsList,
    setFloatingWindowsList,
  }), [floatingWindowsList, setFloatingWindowsList]);

  return (
    <FloatingWindowsContext.Provider value={value}>
      {children}
    </FloatingWindowsContext.Provider>
  );
}

export { FloatingWindowsProvider };
export default FloatingWindowsContext;
